const destroy = () => {
  window.Beamer && window.Beamer.destroy();
};

const init = (params: BeamerUpdateParams) => {
  update(params);
  window.Beamer && window.Beamer.init();
};

const update = (params: BeamerUpdateParams) => {
  window.Beamer && window.Beamer.update(params);
};

export default {
  destroy,
  init,
  update,
};
